<template>
  <Modal :is-open="showViewerInfo && showConnectionLostModalText.length === 0" :closeable="false">

    <div v-if="battleContent['isViewer']" style="display: flex;margin-top:-10px;">

      <div style="width:50%;">
        <div style="display: flex;flex-wrap:wrap;justify-content: left;border-right: 1px solid #dee2e6;">


          <div class="col-5 pokemon-list__entry" v-for="(pokemon) in PokemonEnemyTeam"
               v-bind:key="pokemon.id">

            <PokemonEntryButton
                v-if="(pokemon.hp > 0) && allowPlayerToSwitchPokemonOut  && opponentSeenTeam.includes(pokemon)"
                :pokedex-id="pokemon.pokedex_id"
                :id="pokemon.id"
                :name="''"
                :is-shiny="pokemon.isShiny"
                :sell-price="pokemon.sellPrice"
                :lvl="0"
                :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                :team-slot="pokemon.teamSlot"
                :status-effect="pokemon.statusEffect"
                :special-variant="pokemon.specialVariant"
            />
            <PokemonEntryButton v-else-if="opponentSeenTeam.includes(pokemon)"
                                style="opacity: 0.2;"
                                :pokedex-id="pokemon.pokedex_id"
                                :id="pokemon.id"
                                :name="''"
                                :is-shiny="pokemon.isShiny"
                                :sell-price="pokemon.sellPrice"
                                :lvl="0"
                                :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                                :team-slot="pokemon.teamSlot"
                                :status-effect="pokemon.statusEffect"
                                :special-variant="pokemon.specialVariant"
            />
            <PokemonEntryButton v-else
                                style="opacity: 0.2;"
                                :pokedex-id="0"
                                :id="0"
                                :name="''"
                                :is-shiny="false"
                                :sell-price="0"
                                :lvl="0"
                                :hpPercent="100"
                                :team-slot="pokemon.teamSlot"
                                :status-effect="''"
            />


          </div>
        </div>
        <div v-if="battleEnemyCurrentPokemon"
             style="text-align: center;margin-top:3px;position:absolute; left: 25%; transform: translateX(-50%);">
          {{ battleEnemyCurrentPokemon.trainer_username }}
        </div>


      </div>


      <div style="width:50%;">
        <div style="display: flex;flex-wrap:wrap;justify-content: center;border-left: 1px solid #dee2e6">


          <div class="col-5 pokemon-list__entry" v-for="(pokemon) in PokemonTeam"
               v-bind:key="pokemon.id">

            <PokemonEntryButton
                v-if="(pokemon.hp > 0) && allowPlayerToSwitchPokemonOut && ownSeenTeam.includes(pokemon)"
                :pokedex-id="pokemon.pokedex_id"
                :id="pokemon.id"
                :name="''"
                :is-shiny="pokemon.isShiny"
                :sell-price="pokemon.sellPrice"
                :lvl="0"
                :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                :team-slot="pokemon.teamSlot"
                :status-effect="pokemon.statusEffect"
                :special-variant="pokemon.specialVariant"
            />
            <PokemonEntryButton v-else-if="ownSeenTeam.includes(pokemon)"
                                style="opacity: 0.2;"
                                :pokedex-id="pokemon.pokedex_id"
                                :id="pokemon.id"
                                :name="''"
                                :is-shiny="pokemon.isShiny"
                                :sell-price="pokemon.sellPrice"
                                :lvl="0"
                                :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                                :team-slot="pokemon.teamSlot"
                                :status-effect="pokemon.statusEffect"
                                :special-variant="pokemon.specialVariant"
            />
            <PokemonEntryButton v-else
                                style="opacity: 0.2;"
                                :pokedex-id="0"
                                :id="0"
                                :name="''"
                                :is-shiny="false"
                                :sell-price="0"
                                :lvl="0"
                                :hpPercent="100"
                                :team-slot="pokemon.teamSlot"
                                :status-effect="''"
            />
          </div>


        </div>

        <div v-if="battleOwnCurrentPokemon"
             style="text-align: center;margin-top:3px;position:absolute; left: 75%; transform: translateX(-50%);">
          {{ battleOwnCurrentPokemon.trainer_username }}
        </div>
        <div style="height:20px;">

        </div>
      </div>

    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary"
              @click="showViewerInfo=false;">
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="showConnectionLostModalText.length > 0" :closeable="false">
    <div>{{ showConnectionLostModalText }}</div>

    <template v-if="ShowExitButton" #footer>
      <button id="back-to-menu-button" type="button" class="btn btn-secondary"
              @click="backToMainMenu();">
        {{ translation.general.okay }}
      </button>
    </template>

  </Modal>

  <Modal :is-open="currentBattleIDModalIsOpen && showConnectionLostModalText.length === 0" :closeable="false">
    {{ translation.battle.enterSpectateKey }} <br>
    <input type="text" :value=uniqueBattleKey>

    <template #footer>
      <button type="button" class="btn btn-secondary"
              @click="currentBattleIDModalIsOpen=false;">
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="surrenderModal && showConnectionLostModalText.length === 0" :closeable="false">
    <div v-if="isBattlePrivate">{{ translation.battle.wantToSurrenderPrivate }}</div>
    <div v-else>{{ translation.battle.wantToSurrender }}</div>
    <template #footer>
      <button type="button" class="btn btn-primary"
              @click="surrender();">
        {{ translation.battle.surrenderButton }}
      </button>

      <button type="button" class="btn btn-secondary"
              @click="surrenderModal=false;">
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="popupModal && showConnectionLostModalText.length === 0" :closeable="false">
    <div id="modal_head">{{ modal_header }}</div>

    <div v-if="ShowExitButton">
      <br>
      {{ translation.battle.enterSpectateKey }} <br>
      <input type="text" :value=uniqueBattleKey>
    </div>

    <template v-if="ShowExitButton" #footer>
      <button id="back-to-menu-button" type="button" class="btn btn-secondary"
              @click="backToMainMenu();">
        {{ translation.general.okay }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="changePokemonModal && !battleContent['isViewer'] && showConnectionLostModalText.length === 0"
         :closeable="false">
    <div v-if="!allowPlayerToSwitchPokemonOut">
      Unfortunately, this move precludes any opportunity for you to switch.
      <br>
      <br>
    </div>

    <div class="row p-1">
      <div class="col-4 pokemon-list__entry" v-for="(pokemon, battle_pokemon_id) in PokemonTeam"
           v-bind:key="pokemon.id">


        <PokemonEntryButton
            v-if="(pokemon.hp > 0 && battleOwnCurrentPokemon !== pokemon) && allowPlayerToSwitchPokemonOut"
            style="padding-bottom: 20px;"
            :pokedex-id="pokemon.pokedex_id"
            :id="pokemon.id"
            :name="pokemon.name"
            :is-shiny="pokemon.isShiny"
            :sell-price="pokemon.sellPrice"
            :lvl="pokemon.lvl"
            :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
            :team-slot="pokemon.teamSlot"
            :status-effect="pokemon.statusEffect"
            :special-variant="pokemon.specialVariant"
            @click="changePokemonClicked(pokemon, battle_pokemon_id);"
        />
        <PokemonEntryButton v-else
                            style="padding-bottom: 20px; opacity: 0.2;"
                            :pokedex-id="pokemon.pokedex_id"
                            :id="pokemon.id"
                            :name="pokemon.name"
                            :is-shiny="pokemon.isShiny"
                            :sell-price="pokemon.sellPrice"
                            :lvl="pokemon.lvl"
                            :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                            :team-slot="pokemon.teamSlot"
                            :status-effect="pokemon.statusEffect"
                            :special-variant="pokemon.specialVariant"
        />
      </div>
    </div>

    <div class="battle-remaining-time battle-remaining-time-own"></div>

    <template v-if="battleOwnCurrentPokemon" #footer>
      <button v-if="battleOwnCurrentPokemon.hp !== 0 && showSwitchCancelButton" type="button" class="btn btn-secondary"
              @click="changePokemonModal=false;">
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <div style="position:absolute; width: 100%; height: 100%; background-color: #2c2b2b; z-index: -100"></div>

  <div v-if="!loadingDone"
       style="position:absolute; width: 100%; height: 100%; background-color: rgba(0,0,0,0.75); z-index: 9">

    <div style="position: absolute; left: 50%;top:20%;">
      <div style="position: relative; left: -50%;">

        <div>
          <img :src="imageUri + 'static/twitchextension/loading.gif'" style="width: 100%;">
          <br>

        </div>
        <div style="text-align: center;text-shadow: #000 0 0 5px, #000 0 0 5px, #000 0 0 5px;">
          Loading...
        </div>
      </div>
    </div>

  </div>

  <div id="battle-background" class="ml-auto mr-auto" :style="{ backgroundImage: 'url(' + imageUri +  'static/' + battle_background + '.jpg' + ')' }">

    <div v-if="battleEnemyCurrentPokemon" style="right:0;position: absolute;z-index: 1">
      <div v-if="battleEnemyCurrentPokemon.evolved">

        <tooltip :adjustLeft="-150">
          <div>
            ⚠️
          </div>

          <template #tooltip>
            The Pokemon was evolved! It may not used the normal PCG moveset distribution!
          </template>
        </tooltip>
      </div>

    </div>


    <div id="battle-pokemon-opponent" class="battle-pokemon"></div>
    <div id="battle-pokemon-own" class="battle-pokemon"></div>

    <div class="battle-background__pokeinfo battle-background__pokeinfo--opponent">
      <span class="battle-background__pokeinfo__name">Loading...</span>

      <div v-if="battleEnemyCurrentPokemon">
        <div v-if="battleEnemyCurrentPokemon.statusEffect"
             style="position: absolute;top: 5px;bottom: 37px;left: 120px; right: 0;background-size: contain;background-position: center;background-repeat: no-repeat;"
             :style="{ backgroundImage: 'url(' + require('@/assets/img/status_effects/' + battleEnemyCurrentPokemon.statusEffect + '.svg') + ')' }">
        </div>
      </div>
      <div class="battle-background__pokeinfo__hp"
           style="background: linear-gradient(to right, rgb(88, 177, 48) 0, rgb(105, 206, 132) var(--current-hp), rgb(215, 42, 42) 00%, rgb(243, 84, 84) 100%)">
      </div>

      <div style="display: flex;padding-top:2px;">
        <div v-for="pokemon in PokemonEnemyTeam" :key="pokemon">
          <div v-if="pokemon.hp > 0">
            <img src="https://poketwitch.bframework.de/static/twitchextension/img/balls/poke_ball.svg" alt="ball"
                 style="z-index: 100; width: 22px;">
          </div>
        </div>

        <div v-for="pokemon in PokemonEnemyTeam" :key="pokemon">
          <div v-if="pokemon.hp <= 0">
            <img src="https://poketwitch.bframework.de/static/twitchextension/img/balls/poke_ball.svg" alt="ball"
                 style="z-index: 100; width: 22px;opacity: 0.4">
          </div>
        </div>
      </div>

    </div>


    <div class="battle-background__pokeinfo battle-background__pokeinfo--own">

      <div style="display: flex;margin-top:-25px;position: absolute;right:0;">
        <div v-for="pokemon in PokemonTeam" :key="pokemon">
          <div v-if="pokemon.hp <= 0">
            <img src="https://poketwitch.bframework.de/static/twitchextension/img/balls/poke_ball.svg" alt="ball"
                 style="z-index: 100; width: 11px;opacity: 0.4">
          </div>
        </div>

        <div v-for="pokemon in PokemonTeam" :key="pokemon">
          <div v-if="pokemon.hp > 0">
            <img src="https://poketwitch.bframework.de/static/twitchextension/img/balls/poke_ball.svg" alt="ball"
                 style="z-index: 100; width: 11px;">
          </div>
        </div>


      </div>

      <span class="battle-background__pokeinfo__name">Loading...</span>


      <div v-if="battleOwnCurrentPokemon">
        <div v-if="battleOwnCurrentPokemon.statusEffect"
             style="position: absolute;top: 5px;bottom: 25px;left: 120px; right: 0;background-size: contain;background-position: center;background-repeat: no-repeat;"
             :style="{ backgroundImage: 'url(' + require('@/assets/img/status_effects/' + battleOwnCurrentPokemon.statusEffect + '.svg') + ')' }">
        </div>
      </div>
      <div class="battle-background__pokeinfo__hp text-center"
           style="background: linear-gradient(to right, rgb(88, 177, 48) 0, rgb(105, 206, 132) var(--current-hp), rgb(215, 42, 42) 00%, rgb(243, 84, 84) 100%)">
      </div>

    </div>

  </div>

  <div class="battle-remaining-time battle-remaining-time-opponent"></div>
  <div class="battle-remaining-time battle-remaining-time-own"></div>


  <div id="battle-move-view">
    <div class="container">
      <button class="btn battle-btn mr-auto battle-strugge-btn d-none"
              style="width: 100%; height: 150px;  padding-top: 15px; padding-bottom: 15px;margin-bottom: 10px;"
              @click="struggleBtnClicked">
        {{ translation.battle.struggle }}
      </button>

      <div v-if="!battleContent['isViewer']" class="row battle-buttons-all">
        <button class="btn battle-btn col-5 ml-auto mr-auto battle-move-btn" disabled>
          Loading...
        </button>
        <button class="btn battle-btn col-5 mr-auto battle-move-btn" disabled>
          Loading...
        </button>
        <button class="btn battle-btn col-5 ml-auto mr-auto battle-move-btn" disabled>
          Loading...
        </button>
        <button class="btn battle-btn col-5 mr-auto battle-move-btn" disabled>
          Loading...
        </button>
      </div>

      <div v-if="battleContent['isViewer']" style="display: flex;margin-top:-10px;">

        <div style="width:50%;">
          <div style="display: flex;flex-wrap:wrap;justify-content: left;border-right: 1px solid #dee2e6;">


            <div class="col-5 pokemon-list__entry" v-for="(pokemon) in PokemonEnemyTeam"
                 v-bind:key="pokemon.id">

              <PokemonEntryButton
                  v-if="(pokemon.hp > 0) && allowPlayerToSwitchPokemonOut  && opponentSeenTeam.includes(pokemon)"
                  :pokedex-id="pokemon.pokedex_id"
                  :id="pokemon.id"
                  :name="''"
                  :is-shiny="pokemon.isShiny"
                  :sell-price="pokemon.sellPrice"
                  :lvl="0"
                  :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                  :team-slot="pokemon.teamSlot"
                  :status-effect="pokemon.statusEffect"
                  :special-variant="pokemon.specialVariant"
              />
              <PokemonEntryButton v-else-if="opponentSeenTeam.includes(pokemon)"
                                  style="opacity: 0.2;"
                                  :pokedex-id="pokemon.pokedex_id"
                                  :id="pokemon.id"
                                  :name="''"
                                  :is-shiny="pokemon.isShiny"
                                  :sell-price="pokemon.sellPrice"
                                  :lvl="0"
                                  :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                                  :team-slot="pokemon.teamSlot"
                                  :status-effect="pokemon.statusEffect"
                                  :special-variant="pokemon.specialVariant"
              />
              <PokemonEntryButton v-else
                                  style="opacity: 0.2;"
                                  :pokedex-id="0"
                                  :id="0"
                                  :name="''"
                                  :is-shiny="false"
                                  :sell-price="0"
                                  :lvl="0"
                                  :hpPercent="100"
                                  :team-slot="pokemon.teamSlot"
                                  :status-effect="''"
              />


            </div>
          </div>
          <div v-if="battleEnemyCurrentPokemon"
               style="text-align: center;margin-top:3px;position:absolute; left: 25%; transform: translateX(-50%);">
            {{ battleEnemyCurrentPokemon.trainer_username }}
          </div>


        </div>


        <div style="width:50%;">
          <div style="display: flex;flex-wrap:wrap;justify-content: center;border-left: 1px solid #dee2e6">


            <div class="col-5 pokemon-list__entry" v-for="(pokemon) in PokemonTeam"
                 v-bind:key="pokemon.id">

              <PokemonEntryButton
                  v-if="(pokemon.hp > 0) && allowPlayerToSwitchPokemonOut && ownSeenTeam.includes(pokemon)"
                  :pokedex-id="pokemon.pokedex_id"
                  :id="pokemon.id"
                  :name="''"
                  :is-shiny="pokemon.isShiny"
                  :sell-price="pokemon.sellPrice"
                  :lvl="0"
                  :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                  :team-slot="pokemon.teamSlot"
                  :status-effect="pokemon.statusEffect"
                  :special-variant="pokemon.specialVariant"
              />
              <PokemonEntryButton v-else-if="ownSeenTeam.includes(pokemon)"
                                  style="opacity: 0.2;"
                                  :pokedex-id="pokemon.pokedex_id"
                                  :id="pokemon.id"
                                  :name="''"
                                  :is-shiny="pokemon.isShiny"
                                  :sell-price="pokemon.sellPrice"
                                  :lvl="0"
                                  :hpPercent="(pokemon.hp/pokemon.max_hp)*100"
                                  :team-slot="pokemon.teamSlot"
                                  :status-effect="pokemon.statusEffect"
                                  :special-variant="pokemon.specialVariant"
              />
              <PokemonEntryButton v-else
                                  style="opacity: 0.2;"
                                  :pokedex-id="0"
                                  :id="0"
                                  :name="''"
                                  :is-shiny="false"
                                  :sell-price="0"
                                  :lvl="0"
                                  :hpPercent="100"
                                  :team-slot="pokemon.teamSlot"
                                  :status-effect="''"
              />
            </div>


          </div>

          <div v-if="battleOwnCurrentPokemon"
               style="text-align: center;margin-top:3px;position:absolute; left: 75%; transform: translateX(-50%);">
            {{ battleOwnCurrentPokemon.trainer_username }}
          </div>
          <div style="height:20px;">

          </div>
        </div>

      </div>

      <div v-if="!battleContent['isViewer']" class="row" style="width:100%; margin: 0;">
        <button class="btn btn-secondary ml-auto mr-auto" id="changePokemonButton" style="padding: 10px; width: 55%"
                disabled
                @click="changePokemonModal =true;">
          {{ translation.battle.changePokemonButton }}
        </button>
        <button class="btn btn-secondary ml-auto mr-auto" id="viewBattleIDButton" style="padding: 2px; width: 10%"
                disabled
                @click="currentBattleIDModalIsOpen =true;">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="currentColor"
                  d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
          </svg>
        </button>

        <button class="btn btn-secondary ml-auto mr-auto" id="surrenderButton" style="padding: 10px; width: 25%"
                disabled
                @click="surrenderModal =true;">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="currentColor"
                  d="M6,3A1,1 0 0,1 7,4V4.88C8.06,4.44 9.5,4 11,4C14,4 14,6 16,6C19,6 20,4 20,4V12C20,12 19,14 16,14C13,14 13,12 11,12C8,12 7,14 7,14V21H5V4A1,1 0 0,1 6,3Z"/>
          </svg>
        </button>
      </div>


    </div>
  </div>

  <div id="battle-log-view" class="d-none container">
    <div id="battle-log-text">
      Loading...
    </div>

    <button class="btn battle-btn" id="battle-log-continue">{{ translation.general.continue }}</button>
  </div>

</template>

<script>
import axios from "axios";
import {backendUri, imageUri} from "@/utils/settings";
import $ from "jquery";
import {translation} from "@/utils/translations";
import {ref} from "@vue/reactivity";
import Modal from "@/components/Modal/Modal";
import {battleContent, currentView} from "@/utils/globals";
import {blockButton, unblockButton} from "@/components/ButtonControl/ButtonControl";
import PokemonEntryButton from "@/components/PokemonEntryButton/PokemonEntryButton";
import BattleSlotPanel from "@/views/Battle/BattleSlotPanel";
import {showModalMsg} from "@/components/Modal/modalUtils";
import {handleUnknownError} from "@/utils/utilities";
import {battleSocketUri, battleUri} from "../../utils/settings";
import {autoPlayBattles, showViewerInfo} from "../../utils/globals";
import Tooltip from "@/components/Tooltip/Tooltip";
import BattleWatchQueue from "./BattleWatchQueue.vue";
import {onMounted, onBeforeUnmount} from 'vue';


export default {
  name: "Battle",
  components: {Modal, PokemonEntryButton, Tooltip},
  setup() {
    let battleSocket;

    const ownSeenTeam = ref([]);
    const opponentSeenTeam = ref([]);

    blockButton();
    let popupModal = ref(false);
    let stopOwnTimer = ref(false);
    let stopOpponentTimer = ref(false);
    const battle_background = ref("battle_background");

    let currentBattleIDModalIsOpen = ref(false);
    let showConnectionLostModalText = ref("");

    let changePokemonModal = ref(false);
    let surrenderModal = ref(false);
    let ShowExitButton = ref(false);
    let modal_header = ref(translation.battle.waitForPlayer);

    let battleOwnCurrentPokemon = ref();
    let battleEnemyCurrentPokemon = ref();
    let battlePokemon = {};
    let PokemonTeam = ref([]);
    let PokemonEnemyTeam = ref([]);

    let battleId = undefined;

    let battlePlayers = ref([]);
    let uniqueBattleKey = ref();
    let battleOwnPlayerId = undefined;

    const loadingDone = ref(false);
    const isBattlePrivate = ref(false);
    const showSwitchCancelButton = ref(true);
    const allowPlayerToSwitchPokemonOut = ref(true);
    let allowReconnect = ref(true);
    const allowExitBattle = async () => {
      stopOwnTimer.value = true;
      stopOpponentTimer.value = true;

      allowReconnect.value = false;
      changePokemonModal.value = false;
      surrenderModal.value = false;
      ShowExitButton.value = true;

      battleSocket.close()

      if (autoPlayBattles.value) {
        await new Promise(resolve => setTimeout(resolve, 4500));
        await backToMainMenu()
      }
    }

    const showMsgModal = async (header) => {
      modal_header.value = header;
      popupModal.value = true;
    }

    const showUnclosableMsgModal = async (header) => {
      stopOwnTimer.value = true;
      modal_header.value = header;
      popupModal.value = true;
    }

    const hideModal = async () => {
      popupModal.value = false;
    }

    const backToMainMenu = async () => {
      battleContent.value["isViewer"] = false;

      unblockButton();
      if (autoPlayBattles.value) {
        currentView.value = BattleWatchQueue;
      } else {
        currentView.value = BattleSlotPanel;
      }
    }

    const surrender = async () => {
      if (battleSocket.readyState === WebSocket.OPEN) {
        const encoded = JSON.stringify({
          "action": "forfeit"
        });
        battleSocket.send(encoded);
      }
    }

    const moveBtnClicked = async (btn) => {
      showUnclosableMsgModal(translation.battle.battleWaitForPlayer);
      const moveId = $(btn.currentTarget).attr("data-moveid");

      if (battleSocket.readyState === WebSocket.OPEN) {
        const encoded = JSON.stringify({
          "action": "next_move",
          "move_id": moveId
        });
        battleSocket.send(encoded);
      }

    }

    const struggleBtnClicked = async () => {
      showUnclosableMsgModal(translation.battle.battleWaitForPlayer);

      if (battleSocket.readyState === WebSocket.OPEN) {
        const encoded = JSON.stringify({
          "action": "next_move",
          "move_id": 165
        });
        battleSocket.send(encoded);
      }

    }

    const changePokemonClicked = async (pokemon, battle_pokemon_id) => {
      if (battleContent.value["isViewer"]) {
        return
      }

      if (!changePokemonModal.value) {
        return
      } else {
        changePokemonModal.value = false;
      }
      showUnclosableMsgModal(translation.battle.battleWaitForPlayer);

      if (battleSocket.readyState === WebSocket.OPEN) {
        const encoded = JSON.stringify({
          "action": "change_pokemon",
          "battle_pokemon_id": battle_pokemon_id
        });
        battleSocket.send(encoded);
      }
    }

    let battleQueue = [];

    let reconnectAmount = 0;
    let reconnectTimeout = 5000; // Initial timeout of 3 seconds
    const MAX_TIMEOUT = 60000 * 5; // Maximum timeout of 5 minutes
    const startSocket = async () => {
      let socket_url = "wss://" + battleSocketUri + '/ws/battle/' +
          "?Authorization=" + axios.defaults.headers.common["Authorization"] +
          "&battle_id=" + battleId +
          "&liveView=" + battleContent.value["liveView"] +
          "&isViewer=" + battleContent.value["isViewer"] +
          "&language=" + axios.defaults.headers.common["Accept-Language"] +
          "&player_id=" + battleOwnPlayerId
      battleSocket = new WebSocket(socket_url);

      battleSocket.onopen = function () {
        reconnectTimeout = 5000;
        reconnectAmount = 0;
        showConnectionLostModalText.value = "";
      }

      battleSocket.onclose = function () {
        if (!allowReconnect.value) {
          return
        }

        function updateModalText(timeLeft) {
          if (reconnectAmount > 7) {
            showConnectionLostModalText.value = `Reconnecting failed. `;
            allowExitBattle();
            return
          }

          if (timeLeft === 0) {
            showConnectionLostModalText.value = `Attempting to reconnect...`;
            return
          }

          if (reconnectAmount === 0) {
            showConnectionLostModalText.value = `Connection lost. Reconnecting in ${timeLeft} seconds...`;
          } else {
            showConnectionLostModalText.value = `Reconnecting failed. Reconnect attempt: ${reconnectAmount}. Reconnecting in ${timeLeft} seconds...`;
          }
        }


        // Start countdown and show the initial state
        let timeLeft = reconnectTimeout / 1000;
        updateModalText(timeLeft);

        // Update every second
        const intervalId = setInterval(() => {
          timeLeft -= 1;
          updateModalText(timeLeft);

          // If time runs out, stop the countdown
          if (timeLeft <= 0) {
            clearInterval(intervalId);
          }
          if (reconnectAmount === 7) {
            clearInterval(intervalId);
          }

        }, 1000);

        setTimeout(() => {
          // Stop the countdown if it's still active
          clearInterval(intervalId);

          // Double the timeout duration for the next attempt
          reconnectAmount += 1;
          reconnectTimeout = Math.min(reconnectTimeout, MAX_TIMEOUT);
          startSocket();
        }, reconnectTimeout);
      }

      battleSocket.onmessage = function (e) {
        let data = JSON.parse(e.data);

        if (data.action === "STOP_TIMER") {
          if (data.content.target === battleOwnPlayerId) {
            stopOpponentTimer.value = true;
          }
        } else {
          battleQueue.push(data);
        }


      }


    }
    const acceptBattle = async () => {
      await new Promise(resolve => setTimeout(resolve, 500));

      $("#battle-log-continue").click(() => {
        $("#battle-move-view").removeClass("d-none");
        $("#battle-log-view").addClass("d-none");
      });

      $("#battle-move-view .battle-move-btn").click(moveBtnClicked);

      await axios.post(battleUri + "api/game/ext/battle/search/", {action: "accept"})
          .then((resp) => {
            battleId = resp.data['battle_id'];
            battleOwnPlayerId = resp.data['player_id'];
            uniqueBattleKey.value = resp.data['unique_battle_key'];
            startSocket();
          })
          .catch(error => {
            if (error.response.data.error === 30) {
              showModalMsg("No reservation! Please search again!")
            } else if (error.response.data.error === 15) {
              showModalMsg(error.response.data.msg);
            } else if (error.response.data.error === 100) {
              showModalMsg(
                  translation.battle.userBanned +
                  " " +
                  error.response.data.banned_time_remaining
              );

            } else {
              handleUnknownError(error);
            }
            backToMainMenu()
          })
    }

    const watchBattle = async () => {
      await new Promise(resolve => setTimeout(resolve, 500));

      $("#battle-log-continue").click(() => {
        $("#battle-move-view").removeClass("d-none");
        $("#battle-log-view").addClass("d-none");
      });

      $("#battle-move-view .battle-move-btn").click(moveBtnClicked);
      let uniqueBattleKey = battleContent.value["id"]
      await axios.get(battleUri + "api/game/ext/battle/watch/?" + "uniqueBattleKey=" + uniqueBattleKey)
          .then((resp) => {
            battleId = resp.data['battle_id'];
            battleOwnPlayerId = resp.data['player_id'];
            startSocket();
          })
          .catch(error => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.battle.battleDoesntExist);
            } else {
              handleUnknownError(error);
            }
            backToMainMenu();
          })
    }

    function startTimer(remaining, target) {
      if (target === "own") {
        stopOwnTimer.value = false;
      }
      if (target === "opponent") {
        stopOpponentTimer.value = false;
      }

      const remainingSeconds = remaining;
      let battleRemainingTime = {remaining: remainingSeconds};


      $(battleRemainingTime).animate({remaining: 0}, {
        duration: 1000 * remainingSeconds,
        easing: "linear",
        step: v => {
          if (stopOwnTimer.value && target === "own") { // Check if the animation should be stopped
            $(battleRemainingTime).stop(); // Stop the animation
            return false; // Exit the step function
          }

          if (stopOpponentTimer.value && target === "opponent") {
            $(battleRemainingTime).stop(); // Stop the animation
            return false; // Exit the step function
          }

          let obj = $(".battle-remaining-time-" + target)
          obj.css("--remaining", v + "%");
          // if (target === "own") { // this is only for debugging purposes
          //   obj.text(v);
          // }

        },
        complete: () => {
          // $(".battle-move-btn").attr("disabled", true); // todo sometimes they wont activate after this
        }
      });
      // hideModal();
    }

    function delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    }

    const handleBattle = async (data) => {
      let action = data.action;

      let actionData = data.content;


      await delay(250 * battleContent.value['speed']);


      while (battleContent.value['speed'] > 999) {
        await delay(100);
      }

      if (action === "RE_INIT") {
        for (const playerId in actionData.players) {
          const playerData = actionData.players[playerId];
          if (playerId == battleOwnPlayerId) {
            if (playerData.pokemon[playerData.current_pokemon].hp <= 0) {
              changePokemonModal.value = true;
            }
          }
        }

        $("#battle-log-continue").attr("disabled", true);
        $("#battle-log-text").html("");
        $("#battle-move-view").addClass("d-none");
        $("#battle-log-view").removeClass("d-none");
        hideModal();

        const log = $("#battle-log-text");
        const originalLog = log.html();
        let newLog = "Reinitialized battle!"
        log.html(originalLog + "<p>" + newLog + "</p>");


        // changePokemonModal.value = true;
      }
      if (["INIT", "RE_INIT"].includes(action)) {
        battle_background.value = actionData.bg

        battlePlayers.value = actionData.players
        isBattlePrivate.value = actionData.is_private

        for (const playerId in actionData.players) {

          const playerData = actionData.players[playerId];

          Object.assign(battlePokemon, playerData.pokemon);

          let pokeInfoBox;
          const pokemon = playerData.pokemon[playerData.current_pokemon];
          if (playerId == battleOwnPlayerId) {
            if (!ownSeenTeam.value.includes(pokemon)) {
              ownSeenTeam.value.push(pokemon)
            }

            allowPlayerToSwitchPokemonOut.value = playerData.allowPlayerToSwitchPokemonOut;

            PokemonTeam.value = playerData.pokemon
            battleOwnCurrentPokemon.value = pokemon

            // init own player
            let directory;
            if (pokemon.isShiny) {
              directory = "back-shiny/"
            } else {
              directory = "back/"
            }
            $("#battle-pokemon-own").css("background-image", "url(" + imageUri + "static/pokedex/sprites/" + directory + pokemon.pokedex_id + ".gif)")

            pokeInfoBox = $(".battle-background__pokeinfo--own");
            pokeInfoBox.find(".battle-background__pokeinfo__hp").text(pokemon.hp + "/" + pokemon.max_hp);

            if (!battleContent.value["isViewer"]) {
              $("#changePokemonButton").attr("disabled", false);
              $("#surrenderButton").attr("disabled", false);
              $("#viewBattleIDButton").attr("disabled", false);
            }

            let pp = 0
            for (let [i, [move_id, move]] of Object.entries(pokemon.moves).entries()) {
              const moveBtn = $($(".battle-move-btn")[i]);
              moveBtn.html("<div class=\"battle-move-btn__type\" style=\"background-image: url('" + require('@/assets/img/type-icons/' + move.type + '.svg') + "');position: absolute;top: 10px;bottom: 10px;left: 0;right: 0;background-size: contain;background-position: center;background-repeat: no-repeat;opacity: .5;z-index: -5;\"></div>" + move.name + "<br><span style='color:white;'\">" + move.pp + "/" + move.max_pp + "</span>")

              pp += move.pp
              if (!battleContent.value["isViewer"]) {
                moveBtn.attr("disabled", move.pp === 0);
              }
              moveBtn.attr("data-moveid", move_id);
            }
            if (pp < 1) {
              $(".battle-strugge-btn").removeClass("d-none");
              $(".battle-buttons-all").addClass("d-none");
            } else {
              $(".battle-strugge-btn").addClass("d-none");
              $(".battle-buttons-all").removeClass("d-none");
            }

            for (let i = 0; i < 4 - Object.keys(pokemon.moves).length; i++) {
              const moveBtn = $($(".battle-move-btn")[3 - i]);
              moveBtn.attr("disabled", true);
              moveBtn.text("-")
            }
          } else {
            if (!opponentSeenTeam.value.includes(pokemon)) {
              opponentSeenTeam.value.push(pokemon)
            }

            PokemonEnemyTeam.value = playerData.pokemon

            battleEnemyCurrentPokemon.value = pokemon
            // init opponent
            let directory;
            if (pokemon.isShiny) {
              directory = "front-shiny/"
            } else {
              directory = "front/"
            }
            $("#battle-pokemon-opponent").css("background-image", "url(" + imageUri + "static/pokedex/sprites/" + directory + pokemon.pokedex_id + ".gif)")

            pokeInfoBox = $(".battle-background__pokeinfo--opponent");
          }


          let pokeinfo_name = pokemon.name + ":  " + pokemon.trainer_username
          if (pokeinfo_name.length > 18) {
            pokeinfo_name = pokemon.name + ":  " + pokemon.trainer_username.substring(0, 16 - pokemon.name.length)
          }

          // init pokemon info box
          pokeInfoBox.find(".battle-background__pokeinfo__name").text(pokeinfo_name);

          pokeInfoBox.find(".battle-background__pokeinfo__hp").css("--current-hp", (pokemon.hp * 1.0 / pokemon.max_hp) * 100 + "%");
        }
        // battleState = actionData;
        loadingDone.value = true;
      } else if (action === "AWAITING_NEXT_MOVE") {
        if (actionData.skip.indexOf(battleOwnPlayerId) !== -1) {
          if (battleContent.value['speed'] < 50) {
            await delay(500 * battleContent.value['speed']);
          }
          if (battleContent.value['isViewer'] === false) {
            showUnclosableMsgModal(translation.battle.battleWaitForPlayer);
          }

          await new Promise(resolve => setTimeout(resolve, 500));
        } else {
          $("#battle-log-continue").attr("disabled", false);
          startTimer(actionData.remainingOpponent, "opponent");
          startTimer(actionData.remainingOwn, "own");
        }

      } else if (action === "DAMAGE") {
        const pokemon = battlePokemon[actionData.pokemon];
        const hp_from = pokemon.hp;
        const isOwnPlayer = actionData.player == battleOwnPlayerId;
        pokemon.hp = hp_from - actionData.damage;

        let hpBar;
        let pokemonSprite;
        if (isOwnPlayer) {
          hpBar = $(".battle-background__pokeinfo--own .battle-background__pokeinfo__hp");
          pokemonSprite = $("#battle-pokemon-own");
        } else {
          hpBar = $(".battle-background__pokeinfo--opponent .battle-background__pokeinfo__hp");
          pokemonSprite = $("#battle-pokemon-opponent");
        }
        pokemonSprite.fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50);
        await new Promise(resolve => $({hp: hp_from}).animate({hp: pokemon.hp}, {
          duration: 2000,
          step: v => {
            hpBar.css("--current-hp", 100 * v / pokemon.max_hp + "%");
            if (isOwnPlayer) {
              hpBar.text(Math.round(v) + "/" + pokemon.max_hp);
            }
          },
          complete: resolve
        }));
      } else if (action === "ANIMATION") {
        if (actionData.type === "ATTACK") {
          if (actionData.player == battleOwnPlayerId) {
            const pokemonSprite = $("#battle-pokemon-own");
            pokemonSprite.animate({
              right: "-=20px",
              top: "-=20px"
            }, 200);
            await new Promise(resolve => pokemonSprite.animate({
              right: "+=20px",
              top: "+=20px"
            }, 200, resolve));
          } else {
            const pokemonSprite = $("#battle-pokemon-opponent");
            pokemonSprite.animate({
              left: "-=20px",
              bottom: "-=20px"
            }, 200);
            await new Promise(resolve => pokemonSprite.animate({
              left: "+=20px",
              bottom: "+=20px"
            }, 200, resolve));
          }
        }
        if (actionData.type === "POKEMON_CHANGED") {
          let pokeInfoBox;
          const pokemon = battlePokemon[actionData.pokemon];

          if (actionData.player == battleOwnPlayerId) {
            showSwitchCancelButton.value = true;
            if (!opponentSeenTeam.value.includes(pokemon)) {
              ownSeenTeam.value.push(pokemon)
            }

            battleOwnCurrentPokemon.value = pokemon
            // init own player
            let directory;
            if (pokemon.isShiny) {
              directory = "back-shiny/"
            } else {
              directory = "back/"
            }
            $("#battle-pokemon-own").css("background-image", "url(" + imageUri + "static/pokedex/sprites/" + directory + pokemon.pokedex_id + ".gif)")

            pokeInfoBox = $(".battle-background__pokeinfo--own");
            pokeInfoBox.find(".battle-background__pokeinfo__hp").text(pokemon.hp + "/" + pokemon.max_hp);

            let pp = 0
            for (let [i, [move_id, move]] of Object.entries(pokemon.moves).entries()) {
              const moveBtn = $($(".battle-move-btn")[i]);
              moveBtn.html("<div class=\"battle-move-btn__type\" style=\"background-image: url('" + require('@/assets/img/type-icons/' + move.type + '.svg') + "');position: absolute;top: 10px;bottom: 10px;left: 0;right: 0;background-size: contain;background-position: center;background-repeat: no-repeat;opacity: .6;z-index: -5;\"></div>" + move.name + "<br><span style='color:white;'\">" + move.pp + "/" + move.max_pp + "</span>")
              if (!battleContent.value["isViewer"]) {
                moveBtn.attr("disabled", move.pp === 0);
              }
              moveBtn.attr("data-moveid", move_id);
              pp += move.pp
            }
            if (pp < 1) {
              $(".battle-strugge-btn").removeClass("d-none");
              $(".battle-buttons-all").addClass("d-none");
            } else {
              $(".battle-strugge-btn").addClass("d-none");
              $(".battle-buttons-all").removeClass("d-none");
            }

            for (let i = 0; i < 4 - Object.keys(pokemon.moves).length; i++) {
              const moveBtn = $($(".battle-move-btn")[3 - i]);
              moveBtn.attr("disabled", true);
              moveBtn.text("-")
            }
          } else {
            if (!opponentSeenTeam.value.includes(pokemon)) {
              opponentSeenTeam.value.push(pokemon)
            }

            PokemonEnemyTeam.value[actionData.pokemon] = pokemon;
            battleEnemyCurrentPokemon.value = pokemon
            // init opponent
            let directory;
            if (pokemon.isShiny) {
              directory = "front-shiny/"
            } else {
              directory = "front/"
            }
            $("#battle-pokemon-opponent").css("background-image", "url(" + imageUri + "static/pokedex/sprites/" + directory + pokemon.pokedex_id + ".gif)")

            pokeInfoBox = $(".battle-background__pokeinfo--opponent");
          }

          let pokeinfo_name = pokemon.name + ":  " + pokemon.trainer_username
          if (pokeinfo_name.length > 18) {
            pokeinfo_name = pokemon.name + ":  " + pokemon.trainer_username.substring(0, 16 - pokemon.name.length)
          }

          // init pokemon info box
          pokeInfoBox.find(".battle-background__pokeinfo__name").text(pokeinfo_name);

          // pokeInfoBox.find(".battle-background__pokeinfo__lvl").text("Lv. " + pokemon.lvl);
          pokeInfoBox.find(".battle-background__pokeinfo__hp").css("--current-hp", (pokemon.hp * 1.0 / pokemon.max_hp) * 100 + "%");
        }
        // }
      } else if (action === "AWAITING_NEXT_POKEMON") {
        if (actionData.player == battleOwnPlayerId) {
          showSwitchCancelButton.value = false;
        }

        if (battleContent.value['speed'] < 50) {
          await delay(500 * battleContent.value['speed']);
        }

        if (actionData.player == battleOwnPlayerId) {
          setTimeout(function () {
            changePokemonModal.value = true;
          }, 1000);
        }

        if (actionData.player == battleOwnPlayerId) {
          startTimer(actionData.remainingOwn, "own");
          startTimer(actionData.remainingOpponent, "opponent");
        }

      } else if (action === "LOG") {
        const logType = actionData.type;
        const log = $("#battle-log-text");
        const originalLog = log.html();
        if (logType === "MOVE_USED") {

          const pokemon = battlePokemon[actionData.pokemon];
          const move = pokemon.moves[actionData.move];

          if (actionData.move === 165) {
            const newLog = translation.battle.battleMoveUsed(pokemon.name, translation.battle.struggle);
            log.html(originalLog + "<p>" + newLog + "</p>");
          } else {
            const newLog = translation.battle.battleMoveUsed(pokemon.name, actionData.moveName);
            log.html(originalLog + "<p>" + newLog + "</p>");
            if (actionData.player == battleOwnPlayerId) {
              move.pp -= 1;

              let pp = 0
              for (let [i, [move_id, move]] of Object.entries(pokemon.moves).entries()) {
                const moveBtn = $($(".battle-move-btn")[i]);
                moveBtn.html("<div class=\"battle-move-btn__type\" style=\"background-image: url('" + require('@/assets/img/type-icons/' + move.type + '.svg') + "');position: absolute;top: 10px;bottom: 10px;left: 0;right: 0;background-size: contain;background-position: center;background-repeat: no-repeat;opacity: .6;z-index: -5;\"></div>" + move.name + "<br><span style='color:white;'\">" + move.pp + "/" + move.max_pp + "</span>")
                if (!battleContent.value["isViewer"]) {
                  moveBtn.attr("disabled", move.pp === 0);
                }
                moveBtn.attr("data-moveid", move_id);
                pp += move.pp
              }

              if (pp < 1) {
                $(".battle-strugge-btn").removeClass("d-none");
                $(".battle-buttons-all").addClass("d-none");
              } else {
                $(".battle-strugge-btn").addClass("d-none");
                $(".battle-buttons-all").removeClass("d-none");
              }

            }
          }
        } else if (logType === "MSG") {
          const newLog = actionData.msg;
          log.html(originalLog + "<p>" + newLog + "</p>");

        } else if (logType === "MOVE_USED_NAME") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleMoveUsed(pokemon.name, actionData.move);
          log.html(originalLog + "<p>" + newLog + "</p>");

        } else if (logType === "ATTACK_MISSED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleAttackMissed(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "MOVE_FAILED") {
          const newLog = translation.battle.battleMoveFailed;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "CRITICAL_HIT") {
          const newLog = translation.battle.battleCriticalHit;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "RAIN_END") {
          const newLog = translation.battle.battleRainEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "RAIN_STARTED") {
          const newLog = translation.battle.battleRainStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "SUN_STARTED") {
          const newLog = translation.battle.battleSunStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "SUN_END") {
          const newLog = translation.battle.battleSunEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "HAIL_STARTED") {
          const newLog = translation.battle.battleHailStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "HAIL_END") {
          const newLog = translation.battle.battleHailEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "SANDSTORM_STARTED") {
          const newLog = translation.battle.battleSandstormStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "SANDSTORM_END") {
          const newLog = translation.battle.battleSandstormEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "MIST_STARTED") {
          const newLog = translation.battle.battleMistStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "MIST_PREVENTED") {
          const newLog = translation.battle.battleMistPrevented;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "MIST_END") {
          const newLog = translation.battle.battleMistEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "LIGHT_SCREEN_STARTED") {
          const newLog = translation.battle.battleLightScreenStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "LIGHT_SCREEN_END") {
          const newLog = translation.battle.battleLightScreenEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "REFLECT_STARTED") {
          const newLog = translation.battle.battleReflectStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "REFLECT_END") {
          const newLog = translation.battle.battleReflectEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "HAZE_USED") {
          const newLog = translation.battle.battleHazeUsed;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "TAILWIND_STARTED") {
          const newLog = translation.battle.battleTailwindStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "TAILWIND_END") {
          const newLog = translation.battle.battleTailwindEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "TRICK_ROOM_STARTED") {
          const newLog = translation.battle.battleTrickRoomStarted;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "TRICK_ROOM_END") {
          const newLog = translation.battle.battleTrickRoomEnd;
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "TAUNTED_STARTED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyStartTaunt(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "TAUNTED_END") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyEndTaunt(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "POISON_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyPoison(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = "poison";
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = "poison";
          }

        } else if (logType === "TOXIC_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyToxic(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = "poison";
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = "poison";
          }

        } else if (logType === "PARALYSIS_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyParalysis(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = "paralysis";
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = "paralysis";
          }

        } else if (logType === "BURN_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyBurned(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = "burn";
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = "burn";
          }

        } else if (logType === "SLEEP_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemySleeping(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = "sleep";
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = "sleep";
          }

        } else if (logType === "CONFUSION_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyConfused(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "DISALLOW_SWITCHING") {
          // battlePlayers.value[actionData.player]["username"]
          const pokemon = battlePokemon[actionData.pokemon];
          let newLog = translation.battle.battleDisallowSwitching(pokemon.name)

          const isOwnPlayer = actionData.player === battleOwnPlayerId;
          if (isOwnPlayer) {
            allowPlayerToSwitchPokemonOut.value = false;
          }

          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "ALLOW_SWITCHING") {
          // battlePlayers.value[actionData.player]["username"]
          const pokemon = battlePokemon[actionData.pokemon];
          let newLog = translation.battle.battleAllowSwitching(pokemon.name)

          const isOwnPlayer = actionData.player === battleOwnPlayerId;
          if (isOwnPlayer) {
            allowPlayerToSwitchPokemonOut.value = true;
          }
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "END_CONFUSION") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyEndConfusion(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "END_MAGNET_RISE") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyEndMagnetRise(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "END_BURN") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyEndBurn(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = null;
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = null;
          }
        } else if (logType === "END_PARALYSIS") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyEndParalysis(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = null;
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = null;
          }

        } else if (logType === "END_POISON") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyEndPoison(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = null;
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = null;
          }

        } else if (logType === "FREEZE_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleEnemyFrozen(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = "freeze";
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = "freeze";
          }

        } else if (logType === "IS_SLEEPING") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleIsSleeping(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "IS_FROZEN") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleIsFrozen(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "IS_PARALYZED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleIsParalyzed(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "POKEMON_CHANGED") {

          if (actionData.player !== battleOwnPlayerId) {
            Object.assign(battlePokemon, {[actionData.current_pokemon]: actionData.current_pokemon_data});
          }

          changePokemonModal.value = false;
          const newLog = translation.battle.battlePokemonChanged(actionData.last_pokemon_name, battlePokemon[actionData.current_pokemon].name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "CONFUSED") {
          const pokemon = battlePokemon[actionData.pokemon];

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            for (let [i, [move_id, move]] of Object.entries(pokemon.moves).entries()) {

              if (move_id.toString() === actionData.move.toString()) {
                move.pp += 1
              }

              const moveBtn = $($(".battle-move-btn")[i]);
              moveBtn.html("<div class=\"battle-move-btn__type\" style=\"background-image: url('" + require('@/assets/img/type-icons/' + move.type + '.svg') + "');position: absolute;top: 10px;bottom: 10px;left: 0;right: 0;background-size: contain;background-position: center;background-repeat: no-repeat;opacity: .6;z-index: -5;\"></div>" + move.name + "<br><span style='color:white;'\">" + move.pp + "/" + move.max_pp + "</span>")

              if (!battleContent.value["isViewer"]) {
                moveBtn.attr("disabled", move.pp === 0);
              }
              moveBtn.attr("data-moveid", move_id);
            }
          }

          const newLog = translation.battle.battleConfused(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "FLINCHED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            for (let [i, [move_id, move]] of Object.entries(pokemon.moves).entries()) {

              if (move_id.toString() === actionData.move.toString()) {
                move.pp += 1
              }

              const moveBtn = $($(".battle-move-btn")[i]);
              moveBtn.html("<div class=\"battle-move-btn__type\" style=\"background-image: url('" + require('@/assets/img/type-icons/' + move.type + '.svg') + "');position: absolute;top: 10px;bottom: 10px;left: 0;right: 0;background-size: contain;background-position: center;background-repeat: no-repeat;opacity: .6;z-index: -5;\"></div>" + move.name + "<br><span style='color:white;'\">" + move.pp + "/" + move.max_pp + "</span>")

              if (!battleContent.value["isViewer"]) {
                moveBtn.attr("disabled", move.pp === 0);
              }
              moveBtn.attr("data-moveid", move_id);
            }
          }

          const newLog = translation.battle.battleFlinched(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "WOKE_UP") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleWokeUp(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = null;
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = null;
          }

        } else if (logType === "UNTHAWED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleUnthawed(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          if (isOwnPlayer) {
            battleOwnCurrentPokemon.value.statusEffect = null;
          } else {
            battleEnemyCurrentPokemon.value.statusEffect = null;
          }

        } else if (logType === "RECOIL_APPLIED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleRecoilApplied(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "BURN_DAMAGE") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleBurnDamage(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const hp_from = pokemon.hp;
          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          pokemon.hp = hp_from - actionData.damage;
          let hpBar;
          let pokemonSprite;
          if (isOwnPlayer) {
            hpBar = $(".battle-background__pokeinfo--own .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-own");
          } else {
            hpBar = $(".battle-background__pokeinfo--opponent .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-opponent");
          }
          pokemonSprite.fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50);
          await new Promise(resolve => $({hp: hp_from}).animate({hp: pokemon.hp}, {
            duration: 2000,
            step: v => {
              hpBar.css("--current-hp", 100 * v / pokemon.max_hp + "%");
              if (isOwnPlayer) {
                hpBar.text(Math.round(v) + "/" + pokemon.max_hp);
              }
            },
            complete: resolve
          }));

        } else if (logType === "SANDSTORM_DAMAGE") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleSandstormDamage;
          (pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          // todo why here? what is animation doing? for now we can leave it here lol
          const hp_from = pokemon.hp;
          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          pokemon.hp = hp_from - actionData.damage;
          let hpBar;
          let pokemonSprite;
          if (isOwnPlayer) {
            hpBar = $(".battle-background__pokeinfo--own .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-own");
          } else {
            hpBar = $(".battle-background__pokeinfo--opponent .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-opponent");
          }
          pokemonSprite.fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50);
          await new Promise(resolve => $({hp: hp_from}).animate({hp: pokemon.hp}, {
            duration: 2000,
            step: v => {
              hpBar.css("--current-hp", 100 * v / pokemon.max_hp + "%");
              if (isOwnPlayer) {
                hpBar.text(Math.round(v) + "/" + pokemon.max_hp);
              }
            },
            complete: resolve
          }));
        } else if (logType === "HAIL_DAMAGE") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleHailDamage;
          (pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          // todo why here? what is animation doing? for now we can leave it here lol
          const hp_from = pokemon.hp;
          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          pokemon.hp = hp_from - actionData.damage;
          let hpBar;
          let pokemonSprite;
          if (isOwnPlayer) {
            hpBar = $(".battle-background__pokeinfo--own .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-own");
          } else {
            hpBar = $(".battle-background__pokeinfo--opponent .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-opponent");
          }
          pokemonSprite.fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50);
          await new Promise(resolve => $({hp: hp_from}).animate({hp: pokemon.hp}, {
            duration: 2000,
            step: v => {
              hpBar.css("--current-hp", 100 * v / pokemon.max_hp + "%");
              if (isOwnPlayer) {
                hpBar.text(Math.round(v) + "/" + pokemon.max_hp);
              }
            },
            complete: resolve
          }));
        } else if (logType === "POISON_DAMAGE") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battlePoisonDamage(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          // todo why here? what is animation doing? for now we can leave it here lol
          const hp_from = pokemon.hp;
          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          pokemon.hp = hp_from - actionData.damage;
          let hpBar;
          let pokemonSprite;
          if (isOwnPlayer) {
            hpBar = $(".battle-background__pokeinfo--own .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-own");
          } else {
            hpBar = $(".battle-background__pokeinfo--opponent .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-opponent");
          }
          pokemonSprite.fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50).fadeOut(50).fadeIn(50);
          await new Promise(resolve => $({hp: hp_from}).animate({hp: pokemon.hp}, {
            duration: 2000,
            step: v => {
              hpBar.css("--current-hp", 100 * v / pokemon.max_hp + "%");
              if (isOwnPlayer) {
                hpBar.text(Math.round(v) + "/" + pokemon.max_hp);
              }
            },
            complete: resolve
          }));

        } else if (logType === "HEALED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const newLog = translation.battle.battleHealed(pokemon.name);
          log.html(originalLog + "<p>" + newLog + "</p>");

          const hp_from = pokemon.hp;
          const isOwnPlayer = actionData.player == battleOwnPlayerId;
          pokemon.hp = hp_from + actionData.heal;
          let hpBar;
          let pokemonSprite;
          if (isOwnPlayer) {
            hpBar = $(".battle-background__pokeinfo--own .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-own");
          } else {
            hpBar = $(".battle-background__pokeinfo--opponent .battle-background__pokeinfo__hp");
            pokemonSprite = $("#battle-pokemon-opponent");
          }
          // todo: better heal animation
          pokemonSprite.fadeOut(250).fadeIn(250);
          // pokemonSprite.animate({
          //   color: "#29ff00"
          // }, 1500);

          await new Promise(resolve => $({hp: hp_from}).animate({hp: pokemon.hp}, {
            duration: 2000,
            step: v => {
              hpBar.css("--current-hp", 100 * v / pokemon.max_hp + "%");
              if (isOwnPlayer) {
                hpBar.text(Math.round(v) + "/" + pokemon.max_hp);
              }
            },
            complete: resolve
          }));

        } else if (logType === "MOVE_EFFECTIVE") {
          let newLog;
          if (actionData.factor > 1) {
            newLog = translation.battle.battleEffective;
          } else if (actionData.factor > 0) {
            newLog = translation.battle.battleNotEffective;
          } else {
            newLog = translation.battle.battleNoEffect;
          }
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "MULTIPLE_HITS") {
          const newLog = translation.battle.battleMultipleHits(actionData.amount);
          log.html(originalLog + "<p>" + newLog + "</p>");
        } else if (logType === "STAT_CHANGED") {
          const pokemon = battlePokemon[actionData.pokemon];
          const changeBy = actionData['change_by'];
          let statName;
          switch (actionData.stat) {
            case "attack":
              statName = translation.stat.attack;
              break;
            case "special-attack":
              statName = translation.stat.specialAttack;
              break;
            case "defense":
              statName = translation.stat.defense;
              break;
            case "special-defense":
              statName = translation.stat.specialDefense;
              break;
            case "speed":
              statName = translation.stat.speed;
              break;
            case "accuracy":
              statName = translation.stat.accuracy;
              break;
            case "evasion":
              statName = translation.stat.evasion;
              break;
            default:
              statName = "UNKNOWN";
          }
          let logMsg;
          if (changeBy > 0) {
            if (changeBy === 1) {
              logMsg = translation.battle.battleStatUp1;
            } else if (changeBy === 2) {
              logMsg = translation.battle.battleStatUp2;
            } else {
              logMsg = translation.battle.battleStatUp3;
            }
          } else {
            if (changeBy === -1) {
              logMsg = translation.battle.battleStatDown1;
            } else if (changeBy === -2) {
              logMsg = translation.battle.battleStatDown2;
            } else {
              logMsg = translation.battle.battleStatDown3;
            }
          }
          log.html(originalLog + "<p>" + logMsg(pokemon.name, statName) + "</p>");
        }
      } else if (action === "START_LOG") {
        // TODO: notification popup
        // window.open("https://google.com/", "It's your turn!", "width=700,height=500,status=yes,scrollbars=no,resizable=no");

        // wait for loading modal to show (from button press)
        await new Promise(resolve => setTimeout(resolve, 500));
        $("#battle-log-continue").attr("disabled", true);
        $("#battle-log-text").html("");
        $("#battle-move-view").addClass("d-none");
        $("#battle-log-view").removeClass("d-none");
        hideModal();
      } else if (action === "END") {
        allowExitBattle();
        if (actionData.loser == battleOwnPlayerId) {
          if (actionData.loser_xp > 0) {
            showMsgModal(translation.battle.BattleLose + "\n" + translation.battle.BattleXP(actionData.loser_xp, actionData.loser_cash));
          } else {
            showMsgModal(translation.battle.BattleLose + "\n" + translation.battle.BattleNoXP);
          }
        } else {
          if (actionData.winner_xp > 0) {
            showMsgModal(translation.battle.BattleWin + "\n" + translation.battle.BattleXP(actionData.winner_xp, actionData.winner_cash));
          } else {
            showMsgModal(translation.battle.BattleWin + "\n" + translation.battle.BattleNoXP);
          }
        }
        return false;
      } else if (action === "CANCELLED") {
        allowExitBattle();
        showMsgModal(translation.battle.battleCancelled);
        return false;
      } else if (action === "PLAYER_DID_NOT_ACCEPT") {
        allowExitBattle();
        showMsgModal(translation.battle.battlePlayerNotAccepted);
        return false;
      }
      return true;
    }

    onMounted(() => {
      if (!battleContent.value["isViewer"]) {
        acceptBattle();
      } else {
        watchBattle()
      }

      let timeoutId;
      let isMounted = true;

      async function processQueue() {
        if (!isMounted) return; // Don't proceed if component is unmounted.

        if (!battleContent.value['paused'] || !battleContent.value['isViewer']) { // paused or player
          if (battleQueue.length > 0) {
            let dataToProcess = battleQueue.shift();
            await handleBattle(dataToProcess); // Await the completion of handleBattle
          }
        }

        timeoutId = setTimeout(processQueue, battleContent.value['speed'] * 25);
      }


      processQueue(); // Start processing the queue.

      // Make sure to clear the timeout and stop the recursion when the component is unmounted
      onBeforeUnmount(() => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        stopOwnTimer.value = true;
        stopOpponentTimer.value = true;
        isMounted = false; // Stop the recursion when the component is unmounted.
      });


    });

    return {
      moveBtnClicked,
      backToMainMenu,
      changePokemonClicked,
      translation,
      backendUri,
      modal_header,
      popupModal,
      ShowExitButton,
      changePokemonModal,
      PokemonTeam,
      battleOwnCurrentPokemon,
      battleEnemyCurrentPokemon,
      surrender,
      surrenderModal,
      struggleBtnClicked,
      PokemonEnemyTeam,
      currentBattleIDModalIsOpen,
      uniqueBattleKey,
      battleContent,
      isBattlePrivate,
      showSwitchCancelButton,
      imageUri,
      allowPlayerToSwitchPokemonOut,
      loadingDone,
      ownSeenTeam,
      opponentSeenTeam,
      showViewerInfo,
      showConnectionLostModalText,
      battle_background
    }
  }
}
</script>

<style lang="scss" src="./scss/Battle.scss" scoped></style>